import { createFileRoute } from '@tanstack/react-router';
import { getCheckinById } from '~/fetch/checkins';
import { Card } from '~/components';
import { ShowAll, Container } from '~/components/Filters';

export const Route = createFileRoute('/checkin/$id')({
  component: Component,
  loader: async ({ params }) => {
    const { checkin } = await getCheckinById({ data: { id: params.id } });
    return { checkin };
  },
});

function Component() {
  const data = Route.useLoaderData();
  return (
    <>
      <Container>
        <ShowAll />
      </Container>

      <Card checkin={data.checkin} />
    </>
  );
}
